export enum EToastType {
  ERROR = "error",
  INFO = "info",
  WARNING = "warning",
  SUCCESS = "success",
}

export interface IAlertToastProps {
  message: string | null;
  type: EToastType;
  onDismissCallBack: () => void;
  autoHide?: {
    enabled: boolean;
    hideTimeInSeconds?: number;
  };
}
